import TripsPage from 'components/trips/TripsPage';
import AboutPage from './components/about/AboutPage';
import AdminPage from './components/admin/AdminPage';
import ActivationPage from './components/auth/ActivationPage';
import LoginPage from './components/auth/LoginPage';
import PasswordForgotPage from './components/auth/PasswordForgotPage';
import PasswordResetPage from './components/auth/PasswordResetPage';
import SignUpPage from './components/auth/SignUpPage';
import BillingPage from './components/billing/BillingPage';
import SubscribePage from './components/billing/SubscribePage';
import DocsPage from './components/docs/DocsPage';
import ExplorePage from './components/explore/ExplorePage';
import HomePage from './components/home/HomePage';
import NotFountPage from './components/NotFoundPage';
import SupportPage from './components/support/SupportPage';

export const routes = [
  {
    path: '/',
    exact: true,
    component: HomePage,
    pageProps: {
      pageId: 'home',
      title: 'Home'
    }
  },
  {
    path: '/admin',
    exact: true,
    component: AdminPage,
    pageProps: {
      pageId: 'admin',
      title: 'Admin',
      hideNavigation: true,
      adminOnly: true
    }
  },
  {
    path: '/explore',
    exact: true,
    component: ExplorePage,
    pageProps: {
      pageId: 'explore',
      title: 'Explore',
      // hideNavigation: true
      hideNavigation: false
    }
  },
  {
    path: '/support',
    exact: true,
    component: SupportPage,
    pageProps: {
      pageId: 'support',
      title: 'Support'
    }
  },
  {
    path: '/billing',
    exact: true,
    component: BillingPage,
    pageProps: {
      pageId: 'billing',
      title: 'Billing',
      hideNavigation: true
    }
  },
  {
    path: '/trips',
    exact: true,
    component: TripsPage,
    pageProps: {
      pageId: 'trips',
      title: 'Trips',
      hideNavigation: false
    }
  },
  {
    path: '/subscribe',
    exact: true,
    component: SubscribePage,
    pageProps: {
      pageId: 'subscribe',
      title: 'Choose a plan'
    }
  },
  {
    path: '/about',
    exact: true,
    component: AboutPage,
    pageProps: {
      pageId: 'about',
      title: 'About'
    }
  },
  {
    path: '/docs',
    exact: true,
    component: DocsPage,
    pageProps: {
      pageId: 'docs',
      title: 'docs'
    }
  },
  {
    path: '/login',
    component: LoginPage,
    pageProps: {
      pageId: 'log_in',
      title: 'Log In',
      public: true
    }
  },
  {
    path: '/sign-up',
    component: SignUpPage,
    pageProps: {
      pageId: 'sign_up',
      title: 'Log In',
      public: true
    }
  },
  {
    path: '/password-forgot',
    component: PasswordForgotPage,
    pageProps: {
      pageId: 'password_forgot',
      title: 'Forgot password',
      public: true
    }
  },
  {
    path: '/reset/:token',
    component: PasswordResetPage,
    pageProps: {
      pageId: 'password_reset',
      title: 'Reset password',
      public: true
    }
  },
  {
    path: '/confirm',
    component: ActivationPage,
    pageProps: {
      pageId: 'activation',
      title: 'Account activation',
      public: true
    }
  },
  {
    path: '/*',
    component: NotFountPage,
    pageProps: {
      pageId: 'not_found',
      title: 'Page not found',
      public: true
    }
  }
];
